import { BaseNode } from './BaseNode';

export function WaitNode({ data }: { data: { label: string; seconds?: number } }) {
  return (
    <BaseNode
      type="wait"
      label={data.label}
      lines={[data.seconds != null && { text: `${data.seconds} s` }]}
    />
  );
}
